import { render, staticRenderFns } from "./VersionsTable.vue?vue&type=template&id=df7796a6&"
import script from "./VersionsTable.vue?vue&type=script&lang=ts&"
export * from "./VersionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./VersionsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDataTable,VIcon,VProgressCircular})
